import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { TIndustryForm } from "@/features/learning-content/types/industryForm";
import { CardContainer } from "@/components/commons/CardContainer";
import { InnerBox } from "@/components/elements/InnerBox";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Stack, Typography } from "@mui/material";
import { text } from "@/theme/colors";

type TExamRequirementsFormProps = {};

// Fixed number of requirement boxes (要件1 / 要件2 / 要件3) shown in the form
const REQUIREMENT_BOXES = [0, 1, 2];

export const ExamRequirementsForm: FC<TExamRequirementsFormProps> = () => {
  const { control } = useFormContext<TIndustryForm>();
  // Watch the whole array so each box's 要件の説明文 can be disabled until its 項目名 is filled
  const requirements = useWatch({ control, name: "examRequirements" });

  return (
    <CardContainer sx={{ borderRadius: "8px" }}>
      <Stack gap={3}>
        <Typography variant="sub16Bold" sx={{ fontSize: "20px", fontWeight: 700 }}>
          受験要件
        </Typography>

        {REQUIREMENT_BOXES.map((index) => {
          const hasName = !!requirements?.[index]?.name;

          return (
            <InnerBox
              key={index}
              title={
                <Typography variant="body14" sx={{ fontSize: "14px", fontWeight: 700, color: text.primary }}>
                  要件{index + 1}
                </Typography>
              }
            >
              <Stack gap={2}>
                <FormField control={control} name={`examRequirements.${index}.name`} label="項目名（列名、5文字以下推奨）">
                  <Input fullWidth placeholder="入力してください" />
                </FormField>

                <FormField control={control} name={`examRequirements.${index}.description`} label="要件の説明文">
                  <Input fullWidth placeholder="入力してください" disabled={!hasName} />
                </FormField>
              </Stack>
            </InnerBox>
          );
        })}
      </Stack>
    </CardContainer>
  );
};
